export const containerStyles = `flex flex-col items-center h-full w-full`

export const footerBackgroundImageContainerStyles = `absolute bottom-0 z-10 w-full bg-cover`

export const bodyContainerStyles = `
   flex flex-col items-center justify-start w-full grow pb-[24px]
`

export const headerContainerStyles = `flex items-center justify-center mb-[32px]`

export const footerDetailStyles = `text-sm-regular mb-32`

export const leftAlignedContainerStyles = `flex flex-col h-full w-full`

export const leftAlignedRightContainerStyles = (
   isMediumDevice: boolean
): string =>
   `h-full flex flex-col items-end relative sticky top-0 
${isMediumDevice ? 'w-[66%]' : 'flex-1'}`

export const leftAlignedRightInnerContainerStyles =
   'flex-1 flex items-center justify-center'

export const posterImageStyles = 'w-full max-w-[630px] aspect-square'

export const leftAlignedLayoutFooterStyles =
   'absolute right-[64px] bottom-0 text-right'

export const appLogoStyles = `mx-auto`

export const leftAlignedLoginContainerStyles = `
   flex flex-col items-center h-full left-align-login-container
`

export const loginRightContainer = (isMediumDevice: boolean): string =>
   `h-full pr-5 ${isMediumDevice ? 'w-[100%]' : 'w-[835px]'}`

export const loginRightSubContainer = `flex items-center justify-end w-full`

export const cmNameContainer = `flex flex-col absolute bottom-[46px] right-4 text-center`

export const chiefMinisterInfoStyles = `mt-[6px] cm-info-text text-left`

export const chiefMinisterNameStyles = `cm-info-name`

export const organizationNameContainer =
   'flex justify-end items-center -translate-y-[72px] mr-8'

export const reservedNameStyles = `mt-[33px] text-sm-regular`

export const reservedNameV2Styles = `mt-16px text-sm-medium mx-8px`
